import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConsultationPopup from './ConsultationPopup';

export default function RecommendationsSection() {
  const { t } = useTranslation();
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedTreatment, setSelectedTreatment] = useState('');

  const recommendations = [
    {
      image: 'https://public.readdy.ai/ai/img_res/2862544fe806879ea0c03cc0cfaee0f4.jpg',
      titleKey: 'rec_knee_stem_title',
      descKey: 'rec_knee_stem_desc',
      durationKey: 'rec_knee_stem_duration',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=upper%20eyelid%20surgery%20blepharoplasty%20eye%20cosmetic%20surgery%20before%20after%20elegant%20clinic%20soft%20lighting&width=400&height=320&seq=rec002&orientation=landscape',
      titleKey: 'rec_upper_eyelid_title',
      descKey: 'rec_upper_eyelid_desc',
      durationKey: 'rec_upper_eyelid_duration',
    },
    {
      image: 'https://static.readdy.ai/image/c10e9e76a30b13d22dd14b5eb889b083/1ff44616f54adcb152634c93f50940ed.jpeg',
      titleKey: 'rec_rhinoplasty_title',
      descKey: 'rec_rhinoplasty_desc',
      durationKey: 'rec_rhinoplasty_duration',
    },
    {
      image: 'https://static.readdy.ai/image/c10e9e76a30b13d22dd14b5eb889b083/79780c5f70f2832421ceca689bd4fbec.png',
      titleKey: 'rec_skin_care_title',
      descKey: 'rec_skin_care_desc',
      durationKey: 'rec_skin_care_duration',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=teeth%20whitening%20dental%20cosmetic%20treatment%20bright%20smile%20professional%20dentist%20clinic%20clean%20white%20background&width=400&height=320&seq=rec005&orientation=landscape',
      titleKey: 'rec_teeth_whitening_title',
      descKey: 'rec_teeth_whitening_desc',
      durationKey: 'rec_teeth_whitening_duration',
    },
    {
      image: 'https://static.readdy.ai/image/c10e9e76a30b13d22dd14b5eb889b083/7d5cdcadc0798fd3528fcc1e5f4bbcc8.jpeg',
      titleKey: 'rec_health_checkup_title',
      descKey: 'rec_health_checkup_desc',
      durationKey: 'rec_health_checkup_duration',
    },
    {
      image: 'https://static.readdy.ai/image/c10e9e76a30b13d22dd14b5eb889b083/b361de7093db1aef975603b582be2be3.png',
      titleKey: 'rec_breast_surgery_title',
      descKey: 'rec_breast_surgery_desc',
      durationKey: 'rec_breast_surgery_duration',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=facelift%20surgery%20facial%20rejuvenation%20anti%20aging%20cosmetic%20surgery%20clinic%20professional%20elegant%20result%20clean%20background&width=400&height=320&seq=rec008&orientation=landscape',
      titleKey: 'rec_facelift_title',
      descKey: 'rec_facelift_desc',
      durationKey: 'rec_facelift_duration',
    },
  ];

  const handleCardClick = (titleKey: string) => {
    setSelectedTreatment(t(titleKey));
    setPopupOpen(true);
  };

  return (
    <>
      <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('recommendations_title')}
            </h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              {t('recommendations_subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {recommendations.map((item, index) => (
              <div
                key={index}
                onClick={() => handleCardClick(item.titleKey)}
                className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer group"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={item.image}
                    alt={t(item.titleKey)}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {t(item.titleKey)}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">
                    {t(item.descKey)}
                  </p>
                  <div className="flex items-center text-xs text-gray-500 mb-4">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-time-line mr-1"></i>
                    </div>
                    {t(item.durationKey)}
                  </div>
                  <button
                    onClick={(e) => { e.stopPropagation(); handleCardClick(item.titleKey); }}
                    className="w-full px-4 py-2 bg-teal-600 text-white text-sm font-medium rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {t('book_now')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ConsultationPopup
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        treatmentTitle={selectedTreatment}
      />
    </>
  );
}
